import request from '@/config/axios'

export interface O2oCommissionRuleVO {
  id?: number
  categoryId: number
  categoryName?: string
  catalogServiceId?: number
  serviceName?: string
  subjectType: string
  rate: number
  version?: number
  status?: string
  remark?: string
  platformDefault?: boolean
  serviceOverride?: boolean
  updateTime?: string
}

export interface O2oCommissionRuleLogVO {
  id: number
  ruleId: number
  categoryId: number
  subjectType: string
  oldRate?: number
  newRate: number
  reason: string
  operatorId?: number
  operatorName?: string
  createTime?: string
}

export const getCommissionRuleList = async () => {
  return await request.get<O2oCommissionRuleVO[]>({ url: '/o2o/commission-rule/list' })
}

export const getCommissionServiceList = async (categoryId: number) => {
  return await request.get<O2oCommissionRuleVO[]>({
    url: '/o2o/commission-rule/service-list',
    params: { categoryId }
  })
}

export const getCommissionService = async (catalogServiceId: number) => {
  return await request.get<O2oCommissionRuleVO>({
    url: '/o2o/commission-rule/service-get',
    params: { catalogServiceId }
  })
}

export const updateCommissionRule = async (data: {
  id: number
  rate: number
  reason: string
  remark?: string
}) => {
  return await request.put({ url: '/o2o/commission-rule/update', data })
}

export const saveCommissionServiceOverride = async (data: {
  catalogServiceId: number
  rate?: number
  reason: string
  clear?: boolean
}) => {
  return await request.put({ url: '/o2o/commission-rule/service-override', data })
}

export const getCommissionRuleLogList = async (params: {
  ruleId?: number
  categoryId?: number
  limit?: number
}) => {
  return await request.get<O2oCommissionRuleLogVO[]>({
    url: '/o2o/commission-rule/log/list',
    params
  })
}
